// ----------------------------------------------------------------------

export default function Input(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            "& svg": { color: theme.palette.text.disabled },
          },
        },
        input: {
          "&[type=number]": {
            borderStyle: "none",
            padding: "16.5px 14px",
            background: "transparent",
          },

          "&::placeholder": {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
          /*          ...(process.env?.REACT_APP_TYPE === "free"
            ? {
                "&[type=text]": {
                  color: "currentColor",
                  padding: "4px 0 5px",
                  border: "0",
                  boxSizing: "content-box",
                  background: "none",
                  height: "1.4375em",
                },
                "&[type=text]:focus": {
                  backgroundColor: "transparent",
                  color: "currentColor",
                },
              }
            : {}), */
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[500_12],
          "&:hover": {
            backgroundColor: theme.palette.grey[500_16],
          },
          "&.Mui-focused": {
            backgroundColor: theme.palette.action.focus,
          },
          "&.Mui-disabled": {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        },
        underline: {
          "&:before": {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.grey[500_32],
          },
          "&.Mui-disabled": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.action.disabledBackground,
            },
          },
        },
      },
    },
  };
}
